var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,_vm._b({tag:"component",class:_vm.classes,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClickLink}},'component',_vm.tagProps,false),[(_vm.showSlot)?_c('span',{ref:"slot"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }